import { SubmissionError } from 'redux-form/immutable';
import { push } from 'react-router-redux';

import * as types from './actionTypes';
import studentApi from '../api/studentApi';

export const fetchStudents = (filters, page) => ({
  filters,
  page,
  type: types.FETCH_STUDENTS
});

export const getStudentsSuccess = ({ students, totalPages }, page) => ({
  students,
  totalPages,
  page,
  type: types.GET_STUDENTS_SUCCESS
});

export const getStudentsError = () => ({
  type: types.GET_STUDENTS_ERROR
});

export const getStudentSuccess = student => ({
  student,
  type: types.GET_STUDENT_SUCCESS
});

export const fetchStudent = () => ({
  type: types.FETCH_STUDENT
});

export const getStudentError = () => ({
  type: types.GET_STUDENT_ERROR
});

export const createStudent = student =>
  dispatch =>
    studentApi.create({ student }).then(() => {
      dispatch(push('/alumnos'));
    }).catch((err) => {
      throw new SubmissionError(err.errors);
    });

export const getStudents = (filters, row, page = 1) =>
  (dispatch) => {
    dispatch(fetchStudents(filters, page));
    return studentApi.get(filters, row, page).then((response) => {
      dispatch(getStudentsSuccess(response, page));
    }).catch(() => {
      dispatch(getStudentsError(page));
    });
  };

export const getStudent = id =>
  (dispatch) => {
    dispatch(fetchStudent());
    return studentApi.getStudent(id).then((response) => {
      dispatch(getStudentSuccess(response));
    }).catch(() => {
      dispatch(getStudentError());
    });
  };

export const updateStudent = (student, id) =>
  dispatch =>
    studentApi.update({ student }, id).then(() => {
      dispatch(push(`/alumnos/${id}`));
    }).catch((err) => {
      throw new SubmissionError(err.errors);
    });



// WEBPACK FOOTER //
// ./src/actions/studentActions.js